import * as yup from 'yup'

export const validationSchemaUpdateCompanyAddress = yup.object({
  streetName: yup.string().required('Obrigatório'),
  streetNumber: yup.string().required('Obrigatório'),
  neighborhood: yup.string().required('Obrigatório'),
  city: yup.string().required('Obrigatório'),
  state: yup.string().required('Obrigatório'),
  complement: yup.string(),
})

export const validationSchemaCreateUser = yup.object({
  name: yup.string().required('Obrigatório'),
  email: yup.string().email('E-mail inválido').required('Obrigatório'),
  password: yup
    .string()
    .required('Obrigatório')
    .min(6, 'Mínimo de 6 caracteres')
    .matches(/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*])(?=.{8,})/, ' '),
  confirmPassword: yup
    .string()
    .required('Obrigatório')
    .oneOf([yup.ref('password')], 'As senhas devem ser iguais'),
})

export const validationSchemaUpdateUser = yup.object({
  name: yup.string().required('Obrigatório'),
  currentPassword: yup.string(),
  password: yup
    .string()
    .min(6, 'Mínimo de 6 caracteres')
    .matches(
      /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*])(?=.{8,})/,
      'A senha deve conter pelo menos uma letra maiúscula, uma letra minúscula e um número',
    )
    .when('currentPassword', (currentPassword: string[], schema: any) => {
      const value = String(currentPassword).trim().length > 0
      return value ? schema.required('Obrigatório') : schema
    }),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'As senhas devem ser iguais')
    .when('password', (password: string[], schema: any) => {
      const value = String(password).trim().length > 0
      return value ? schema.required('Obrigatório') : schema
    }),
})
